import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { planManagementQueries } from '@/services/planManagement/planManagement.queries';

export const useGetClubPlanDetail = (clubId: string, planId: string) => {
  const { data: clubPlanDetails, isLoading } = useQuery({
    ...planManagementQueries.detail({ clubId, planId }),
    enabled: !!clubId && !!planId,
  });

  return {
    clubPlanDetails: clubPlanDetails?.data,
    isLoading,
  };
};
